import { styled } from '@mui/material/styles';
import Sticky from 'react-sticky-el';

export const StyledSticky = styled(Sticky)({
  zIndex: 1000,

  '& > div': {
    transform: 'none !important',
  },
});

export const NavDesktopOnly = styled('div')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    display: 'block',
  },
}));
